import { STORAGE, STORAGE_KEY } from "@/constants";
import { getItem, setItem } from "@/lib/storage-utils";

let cachedInstanceId: string | null = null;

/**
 * Returns a stable per-session instance id.
 * Stored in sessionStorage for reuse across the app lifecycle.
 */
export function getOrCreateInstanceId(): string {
  if (cachedInstanceId) return cachedInstanceId;

  const existing = getItem<string>(
    STORAGE_KEY.APP_INSTANCE_ID,
    STORAGE.SESSION,
  );
  if (typeof existing === "string" && existing.trim()) {
    cachedInstanceId = existing;
    return cachedInstanceId;
  }

  const created = crypto.randomUUID();
  setItem(STORAGE_KEY.APP_INSTANCE_ID, created, STORAGE.SESSION);
  cachedInstanceId = created;
  return cachedInstanceId;
}
